<template>
  <div class="anomaly-list">
    <div
      v-for="(a, i) in list" :key="`${a.uf}-${i}`" class="anomaly-item"
      :class="severityCls(a.type)"
    >
      <div class="badge-uf">{{ a.uf }}</div>
      <div class="meta">
        <div class="t1">{{ a.companyName }}</div>
        <div style="display: table;">
          <div style="display: table-cell">
            <div v-for="b in a.changeFields" :key="b" class="pt">{{ b }}：</div>
          </div>
          <div style="display: table-cell;">
            <div v-for="b in a.beforeValues" :key="b" class="pt">{{ b }} -></div>
          </div>
          <div style="display: table-cell;">
            <div v-for="b in a.afterValues" :key="b" class="pt">{{ b }}</div>
          </div>
        </div>
        <div class="t2">
          <span>{{ reasonOf(a).zh }}<span class="pt"> / {{ reasonOf(a).pt }}</span></span>
        </div>
      </div>
      <div class="right">
        <span class="time">{{ fmtCheckTime(a.lastCheckTime) }}</span>
      </div>
      <a class="action" @click="$emit('view', a)">查看 <span class="pt"> / Ver ›</span></a>
    </div>
    <div v-if="!list.length" class="empty">暂无异常主体<span class="pt"> / Nenhuma entidade com exceção</span></div>
  </div>
</template>

<script>
import { TAX_LABEL, SYS_LABEL } from '../mock';

/** 异常原因：接口只给状态枚举，原因文案按税务 / 系统状态推导（中葡） */
const TAX_REASON = {
  2: { zh: 'IE 失效（被注销）', pt: 'IE Baixada (cancelada)' },
  3: { zh: '税务状态未知', pt: 'Status fiscal desconhecido' },
  4: { zh: '税务资质未录入', pt: 'Qualificação fiscal não registrada' }
};
const SYS_REASON = {
  2: { zh: '系统未配置开票主体', pt: 'Entidade emissora não configurada no sistema' }
};

export default {
  name: 'AnomalyList',
  props: {
    // 异常主体清单（字段同接口 data：uf / companyName / taxStatus / sysStatus / overallStatus / lastCheckTime）
    list: { type: Array, default: () => [] }
  },
  methods: {
    /** 行左侧色条：overallStatus 3异常红 / 2警告橙 / 其余（正常、停用）绿 */
    severityCls(overallStatus) {
      if (overallStatus === 3) return 'err';
      if (overallStatus === 2) return 'warn';
      return 'ok';
    },
    /** 异常原因（中葡）：优先税务状态原因，其次系统配置原因，最后兜底 */
    reasonOf(row) {
      return TAX_REASON[row.taxStatus] || SYS_REASON[row.sysStatus] || {
        zh: '综合状态异常',
        pt: 'Exceção no status geral'
      };
    },
    /** 最近检查时间 ISO → HH:mm:ss */
    fmtCheckTime(value) {
      if (!value) return '—';
      const d = new Date(value);
      if (isNaN(d.getTime())) return '—';
      const pad = n => String(n).padStart(2, '0');
      return `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    /** 状态枚举 → 中葡文案（税务 / 系统） */
    statusZh(status) {
      return (TAX_LABEL[status] || SYS_LABEL[status] || {}).zh || '—';
    }
  }
};
</script>

<style scoped lang="scss">
.anomaly-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 20px;
}
.anomaly-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border: 1px solid #e5e6eb;
  border-radius: 6px;
  background: #fff;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.anomaly-item:hover {
  box-shadow: 0 2px 8px rgba(29, 33, 41, 0.06);
}
.anomaly-item.err { border-left: 3px solid #f53f3f; }
.anomaly-item.warn { border-left: 3px solid #ff7d00; }
.anomaly-item.ok { border-left: 3px solid #00a551; }
.anomaly-item .badge-uf {
  width: 36px;
  height: 36px;
  border-radius: 6px;
  background: #e8f7f0;
  color: #00a551;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 13px;
  flex-shrink: 0;
}
.anomaly-item .meta {
  flex: 1;
  min-width: 0;
}
.anomaly-item .meta .t1 {
  font-weight: 600;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.anomaly-item .meta .t2 {
  color: #86909c;
  font-size: 12px;
  margin-top: 2px;
  line-height: 1.5;
}
.anomaly-item .pt {
  font-size: 12px;
  color: #86909c;
}
.anomaly-item .flow .pt {
  white-space: nowrap;
}
.anomaly-item .right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  flex-shrink: 0;
}
.anomaly-item .time {
  color: #86909c;
  font-size: 12px;
}
.anomaly-item .action {
  font-size: 12px;
  color: #00a551;
  cursor: pointer;
  white-space: nowrap;
}
.anomaly-item .action:hover {
  text-decoration: underline;
}
.tag {
  display: inline-flex;
  align-items: center;
  padding: 1px 8px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 4px;
  line-height: 18px;
  white-space: nowrap;
}
.tag-ok { background: #e8f7e9; color: #00b42a; }
.tag-err { background: #ffecec; color: #f53f3f; }
.tag-warn { background: #fff3e0; color: #ff7d00; }
.empty {
  padding: 24px;
  text-align: center;
  color: #86909c;
  font-size: 13px;
}
</style>
